<template>
  <div class="challenge-header-desk">
    <v-row class="align-center mx-10 mt-4">
        <v-col cols="auto">
          <v-btn
            icon
            tile
            small
            color="primary"
            class="bg-secondary-50 rounded"
            @click="$router.go('challenge')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3" class="d-flex ml-120 justify-content-end">
          <v-btn
            outlined
            dense
            small
            color="primary"
            class="border-radius-1 text-transform-none pl-4 ml-4 position-relative"
            @click="openDialog"
          >
            <v-img
              :src="require(`@/assets/img/icons/treasure.png`)"
              height="48px"
              width="48px"
              class="image-overlay"
            ></v-img>
            {{$t('challenge.rewards')}}
          </v-btn>
        </v-col>
      </v-row>
    
    <PrizeChallenge :dialogVisible="dialogVisible" />
  </div>
</template>

<script>
import PrizeChallenge from '../PrizeChallenge.vue';

export default {
  components: {
    PrizeChallenge,
  },
  data () {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    // Open dialog recompensas
    openDialog() {
      this.$root.$emit('openDialog', true);
    },
  },
}
</script>

<style lang="scss">
.image-overlay {
  position: absolute;
  top: -12px;
  left: -46px;
  z-index: 1;
}
.v-sheet.v-toolbar.v-app-bar {
  padding-top: 0;
}
.justify-content-end {
  justify-content: end;
}
.ml-120{
  margin-left: auto;
  @media screen {
    max-width: 767px {
      margin-left: 120px;
    }
  }
}
</style>